<template>
    <div>
        <transition-group
                tag="ul"
                name="fade"
                class="avatars"
        >
            <li
                    class="avatars__item"
                    v-for="user in displayUsers"
                    :key="user.internalLocalIndex"
                    :class="{overlapped: overlapped}"
            >
                <storage-avatar
                        :user="user"
                        :show-tooltip="showAvatarTooltips"
                />
            </li>
            <li
                    class="avatars__item align-self-center"
                    v-if="this.users.length-displayUsers.length > 0"
                    :key="this.users.length"
                    :class="{overlapped: overlapped}"
            >
                <div
                        :id="id"
                        class="avatar alert-secondary load-more"
                        @click="loadAllUsers()"
                >
                    +{{ this.users.length-displayUsers.length }}
                </div>
                <b-tooltip
                        v-if="this.users.length-displayUsers.length > 0"
                        :target="id"
                        triggers="hover"
                >
                    <div
                            v-for="(member,key) in tooltipsMembers"
                            :key="key"
                            class="text-left"
                    >
                        {{ member.fullName }}
                    </div>
                </b-tooltip>
            </li>
        </transition-group>
    </div>
</template>

<script>
    import StorageAvatar from "./StorageAvatar";
    import AppResourceCollection from '@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection';
    import {generateRandomString} from "@milestoneslabs/milestones-ui-kit/src/helpers/stringHelpers";

    export default {
        name: 'StorageAvatarNested',
        components: {StorageAvatar},
        props: {
            users: {
                type: [Array, AppResourceCollection],
                required: true,
            },
            numberOfUsers: {
                type: Number,
                default: 3,
            },
            maxUsers: {
                type: Number,
                default: 10,
            },
            overlapped: {
                type: Boolean,
                default: false,
            },
            preventLoadMoreAction: {
                type: Boolean,
                default: false
            },
            showAvatarTooltips: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showAll: false,
                id: 'nested-avatar-' + generateRandomString(32),
            };
        },
        computed: {
            itemStyle() {
                return this.overlapped ? 'margin-left: 5px' : null;
            },
            localUsers() {
                return this.users.map((el, index) => {
                    el.internalLocalIndex = index;

                    return el;
                });
            },
            displayUsers() {
                return this.localUsers.slice(0, this.showAll ? this.maxUsers : this.numberOfUsers);
            },
            tooltipsMembers() {
                return this.localUsers.slice(this.numberOfUsers);
            }
        },
        methods: {
            loadAllUsers: function () {
                if (!this.preventLoadMoreAction) {
                    this.showAll = true;
                }
            },
        },
    };
</script>

<style
        scoped
        lang="scss"
>

    ul.avatars {

        display: flex;
        /* Causes LI items to display in row. */

        list-style-type: none;

        margin: auto;
        /* Centers vertically / horizontally in flex container. */
        padding: 0px 7px 0px 0px;
        z-index: 1;
        /* Sets up new stack-container. */
    }

    .load-more {
        cursor: pointer;

        padding: 0.2rem 0.6rem !important;
        border-radius: 0.9rem;
    }

    .load-more-disabled {
        cursor: auto;
    }

    li.avatars__item {
        border-right: 1px solid white;
        border-radius: 100%;
        box-shadow: 1px 0 2px 0 #FFFFFF;
        position: relative;

        &:not(:first-child) {
            margin-left: 5px;
        }

        &.overlapped:not(:first-child) {
            margin-left: -0.625rem;
        }
    }

    @for $i from 1 through 50 {
        li.avatars__item:nth-child( #{$i} ) {
            z-index: 50-$i;
        }
    }

    .fade-enter-active, .fade-leave-active {

        transition: all .2s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;

    }

    .fade-enter-active {
        transition-delay: .2s;

    }

</style>
